import { compose, reduce, map, ifElse, keys, equals, always } from 'ramda'

import { createTheme } from '@material-ui/core/styles'

import { default as createSpacing } from '@material-ui/core/styles/createSpacing'

import palette from 'app/clientTheme/palettes'

const spacing = createSpacing()

const typography = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: 14,
  htmlFontSize: 16,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500
}

const overrides = {
  MuiCssBaseline: {
    '@global': {
      '.grecaptcha-badge': {
        visibility: 'hidden'
      },
      '.recharts-default-legend': {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        rowGap: '4px',
        columnGap: '8px'
      }
    }
  },
  MuiFormLabel: {
    root: {
      '&$error': {
        '&:not($focused) + div > div': {
          color: `${palette.error.main}`
        }
      },
      '&$required': {
        '& > span': {
          color: `${palette.error.main}`
        }
      }
    }
  },
  MuiInput: {
    root: {
      fontWeight: 500,
      '&:before, &:before': {
        borderBottom: `1px solid ${palette.grey[400]}`
      },
      '&$disabled': {
        color: `${palette.grey[500]}`,
        '&:after, &:before': {
          borderBottom: `1px solid ${palette.grey[400]} !important`
        }
      }
    }
  },
  MuiTableCell: {
    root: {
      fontSize: '0.75rem',
      padding: spacing(0.5, 7, 0.5, 3)
    },
    head: {
      color: palette.grey[600]
    }
  },
  MuiInputAdornment: {
    root: {
      marginLeft: spacing(1),
      marginRight: spacing(2),
      color: palette.text.secondary
    }
  },
  MuiDrawer: {
    paper: {
      overflow: 'hidden'
    }
  },
  MuiButton: {
    root: {
      boxShadow: 'none !important'
    },
    contained: {
      backgroundColor: palette.grey[100]
    }
  },
  MuiMenuItem: {
    root: {
      height: spacing(3),
      paddingTop: spacing(1) + 3,
      paddingBottom: spacing(1) + 3,
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
      boxSizing: 'content-box'
    }
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        zIndex: 9999
      }
    }
  }
}

const zIndex = {
  dropdownPopper: 900,
  loading: 1400
}

const theme = createTheme({
  palette,
  overrides,
  typography,
  zIndex
})

theme.mixins.toolbar = compose(
  reduce((acc, item) => ({ ...acc, ...item }), {}),
  map(
    ifElse(
      equals('minHeight'),
      always({
        minHeight: theme.mixins.toolbar.minHeight + 'px'
      }),
      key => ({
        [key]: {
          minHeight: theme.mixins.toolbar[key].minHeight + 'px'
        }
      })
    )
  ),
  keys
)(theme.mixins.toolbar)

export default theme
